import { gql } from "generated-graphql";

export const MANIFEST_DOCUMENTS_QUERY = gql(`
  query ManifestDocuments($search: String, $page: Int, $pageSize: Int, $sort: [SortModel!]) {
    documents(search: $search, page: $page, pageSize: $pageSize, sort: $sort) {
      count
      items {
        id
        title
        tenantId
        documentType
        originalDocumentType
        fileExtension
        storageLink
        extractionStatus
        extractionError
        lastExtractionAt
        createdAt
        documentMetadata {
          needsReview
        }
        facilities {
          id
          epaIdStatuses {
            epaId
            isInactive
            isPrimaryForFacility
          }
        }
        sourceWasteManifest {
          id
          manifestTrackingNumber
          generatorId
          shippedDate
        }
        sourceProcessedManifest {
          id
          manifestTrackingNumber
          facility {
            id
            name
          }
        }
      }
    }
  }
`);
